import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { SeacrhCriteriaItem } from "./SearchCriteriaItem";

class SearchCriteriaListItem implements ITableDataSourceItem<SeacrhCriteriaItem> {
    public Model: SeacrhCriteriaItem;
    public Name: string;

    constructor(model: SeacrhCriteriaItem) {
        this.Model = model;
    }
}

export { SearchCriteriaListItem };
